function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { KZUIComponent, Row, Col, Input, Dialog, Button, prompt } from '@kuaizhan/kui';
import { passportLogin } from '../../passport/actions';
import './style.less';
var emptyGif = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

var LoginDialog = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(LoginDialog, _KZUIComponent);

  var _super = _createSuper(LoginDialog);

  function LoginDialog(props) {
    var _this;

    _classCallCheck(this, LoginDialog);

    _this = _super.call(this, props);
    _this.state = {
      vcodeImage: emptyGif,
      formToken: ''
    };
    _this.formData = {};

    _this.autoBind('handleFieldChange', 'handleLogin', 'handleVcodeClick');

    return _this;
  }

  _createClass(LoginDialog, [{
    key: "handleLogin",
    value: function handleLogin() {
      this.props.dispatch(passportLogin(this.context.ds, this.formData));
    }
  }, {
    key: "handleFieldChange",
    value: function handleFieldChange(_ref) {
      var name = _ref.name,
          value = _ref.value;
      this.formData[name] = value;
    }
  }, {
    key: "handleVcodeClick",
    value: function handleVcodeClick() {
      this.refreshVcode();
    }
  }, {
    key: "refreshVcode",
    value: function refreshVcode() {
      var _this2 = this;

      this.context.ds.resolve('v2/vcode.get').then(function (res) {
        if (res.status === 200) {
          var data = res.body;

          if (data.ret === 0) {
            _this2.handleFieldChange({
              name: 'form_token',
              value: data.data.form_token
            });

            _this2.setState({
              vcodeImage: "data:image/png;base64,".concat(data.data.vcode_image),
              formToken: data.data.form_token
            });
          }
        } else {
          prompt.alert('获取验证码失败');
        }
      }).catch(function () {
        prompt.alert('获取验证码失败');
      });
    }
  }, {
    key: "render",
    value: function render() {
      var clsPrefix = 'kz-login-dialog';
      var stateClass = {};

      if (this.props.position) {
        stateClass[this.props.position] = true;
      }

      if (!this.props.hide && this.state.formToken === '') {
        this.refreshVcode();
      }

      var imgSrc = this.state.vcodeImage;
      var className = classNames(clsPrefix, stateClass);
      var dialogStyle = {
        padding: '20px'
      };
      return /*#__PURE__*/React.createElement(Dialog, {
        modal: true,
        style: dialogStyle,
        hide: this.props.hide,
        className: className
      }, /*#__PURE__*/React.createElement("div", {
        className: "dialog-title"
      }, "\u767B\u5F55\u5FEB\u7AD9"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Row, {
        gutter: 16
      }, /*#__PURE__*/React.createElement(Col, {
        span: 6,
        className: "".concat(clsPrefix, "--label")
      }, "\u7528\u6237\u540D"), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--cell")
      }, /*#__PURE__*/React.createElement(Input, {
        name: "username",
        onChange: this.handleFieldChange
      }))), /*#__PURE__*/React.createElement(Row, {
        gutter: 16
      }, /*#__PURE__*/React.createElement(Col, {
        span: 6,
        className: "".concat(clsPrefix, "--label")
      }, "\u5BC6\u7801"), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--cell")
      }, /*#__PURE__*/React.createElement(Input, {
        type: "password",
        name: "password",
        onChange: this.handleFieldChange
      }))), /*#__PURE__*/React.createElement(Row, {
        gutter: 16
      }, /*#__PURE__*/React.createElement(Col, {
        span: 6,
        className: "".concat(clsPrefix, "--label")
      }, "\u9A8C\u8BC1\u7801"), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--cell ").concat(clsPrefix, "--cell__half")
      }, /*#__PURE__*/React.createElement(Input, {
        name: "vcode",
        onChange: this.handleFieldChange
      })), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--cell ").concat(clsPrefix, "--cell__half")
      }, /*#__PURE__*/React.createElement("a", {
        className: "".concat(clsPrefix, "--vcode"),
        role: "button",
        tabIndex: 0,
        onClick: this.handleVcodeClick
      }, /*#__PURE__*/React.createElement("img", {
        className: "vcode",
        src: imgSrc,
        alt: "\u9A8C\u8BC1\u7801\u52A0\u8F7D\u4E2D",
        width: "85",
        height: "28"
      })))), /*#__PURE__*/React.createElement("div", {
        className: "".concat(clsPrefix, "--foot")
      }, /*#__PURE__*/React.createElement(Button, {
        type: "primary",
        onClick: this.handleLogin
      }, "\u767B\u5F55"))));
    }
  }]);

  return LoginDialog;
}(KZUIComponent);

LoginDialog.contextTypes = {
  ds: PropTypes.object
};
LoginDialog.propTypes = {
  hide: PropTypes.bool
};
LoginDialog.defaultProps = {
  hide: true
};
export default connect(function (state) {
  return {
    hide: state.passport.status !== 'offline'
  };
})(LoginDialog);